import { render, staticRenderFns } from "./EditarMenu.vue?vue&type=template&id=0f416a6a"
import script from "./EditarMenu.vue?vue&type=script&lang=js"
export * from "./EditarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports